import './styles.css';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { createBrowserRouter } from 'react-router';
import { RouterProvider } from 'react-router/dom';
import { Shell } from './components/Shell';
import { ApiError } from './lib/api';
import { Discovery } from './pages/Discovery';
import { RoomPage } from './pages/Room';
import { InviteAccept, SignIn } from './pages/SignIn';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 15_000,
      refetchOnWindowFocus: true,
      retry: (count, err) =>
        !(err instanceof ApiError && err.status >= 400 && err.status < 500) && count < 2,
    },
  },
});

const router = createBrowserRouter([
  {
    element: <Shell />,
    HydrateFallback: () => null,
    children: [
      { index: true, element: <Discovery /> },
      { path: 'r/:slug', element: <RoomPage /> },
      {
        path: 'library',
        lazy: async () => ({ Component: (await import('./pages/Library')).Library }),
      },
      {
        path: 'profile',
        lazy: async () => ({ Component: (await import('./pages/Profile')).Profile }),
      },
      {
        path: 'u/:handle',
        lazy: async () => ({ Component: (await import('./pages/Profile')).PublicProfilePage }),
      },
      { path: 'signin', element: <SignIn /> },
      { path: 'invite/:token', element: <InviteAccept /> },
      { path: 'admin', lazy: async () => ({ Component: (await import('./pages/Admin')).Admin }) },
      { path: 'terms', lazy: async () => ({ Component: (await import('./pages/Legal')).Terms }) },
      {
        path: 'privacy',
        lazy: async () => ({ Component: (await import('./pages/Legal')).Privacy }),
      },
      {
        path: 'youtube',
        lazy: async () => ({ Component: (await import('./pages/Legal')).YouTubeDisclosure }),
      },
      { path: '*', lazy: async () => ({ Component: (await import('./pages/Legal')).NotFound }) },
    ],
  },
]);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);
